<script lang="ts">

    let serviceId = "mini.valet.small.car"
    let inviteId = null
    let tenantId = null
    let environmentId = null
    let paymentRequest = null

    function submit() {
        var searchParams = new URLSearchParams(window.location.search);
        if (serviceId) {
            searchParams.set("serviceId", serviceId)
        } else if (inviteId) {
            searchParams.set("inviteId", inviteId)
        } else if (paymentRequest) {
            searchParams.set("paymentRequest", paymentRequest)
        } else {
            return
        }
        if (tenantId) {
            searchParams.set("tenantId", tenantId)
        }
        if (environmentId) {
            searchParams.set("environmentId", environmentId)
        }
        window.location.search = searchParams.toString();
    }
</script>
<p>Must supply one of serviceId, inviteId or paymentRequest</p>
<form>
    <input class="form-control" type="text" name="serviceId" placeholder="Service ID" bind:value={serviceId}>
    <input class="form-control" type="text" name="inviteId" placeholder="Invite ID" bind:value={inviteId}>
    <input class="form-control" type="text" name="paymentRequest" placeholder="Payment request"
           bind:value={paymentRequest}>
    <input class="form-control" type="text" name="tenantId" placeholder="Tenant ID" bind:value={tenantId}>
    <input class="form-control" type="text" name="environmentId" placeholder="Environment ID"
           bind:value={environmentId}>
    <button class="btn btn-success" on:click|preventDefault={submit}>Submit</button>
</form>
